import poll from '../api/poll-game.api'

const state = {
  poll: null,
  pollResponses: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  modifyPoll (state, newState) {
    state.poll = newState
  },
  modifyPollResponse (state, newState) {
    state.pollResponses = newState
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getPoll (context, pollId) {
    poll.api.getPoll(pollId)
      .then(response => {
        context.commit('modifyPoll', response.data)
      },
      error => {
        console.log('impossible to load ranking from api: ')
        console.log(error)
      })
  },
  getPollResponse (context) {
    poll.api.getPollResponse()
      .then(response => {
        if (response.data.length > 0) {
          context.commit('modifyPollResponse', response.data)
        }
      },
      error => {
        console.log('impossible to load ranking from api: ')
        console.log(error)
      })
  }
}
// getters are functions
const getters = {
  poll: state => {
    return state.poll
  },
  pollResponses: state => {
    return state.pollResponses
  },
  pollResponseForPoll: state => pollId => {
    if (state.pollResponses === null) {
      return null
    }
    return state.pollResponses.filter(pr => {
      return pr.related_poll === pollId
    })
  },
  pollResponseForQuestion: state => (pollId, questionId) => {
    if (state.pollResponses === null) {
      return null
    }
    return state.pollResponses.filter(pr => {
      return pr.related_poll === pollId && pr.related_question === questionId
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/poll.js